import { cn } from '@/shadcn-ui/utils';
import CatalogBackgroundGradientSVG from './catalog-background-gradient-svg';
import ReactDOMServer from 'react-dom/server';

interface CatalogBackgroundGradientProps {
  className?: string;
}

export default function CatalogBackgroundGradient({
  className,
}: CatalogBackgroundGradientProps) {
  const background = encodeURIComponent(
    ReactDOMServer.renderToStaticMarkup(<CatalogBackgroundGradientSVG />)
  );

  return (
    <>
      <div
        className={cn(
          'absolute -top-[115px] -z-[2] h-full w-full bg-flexcar-blue10',
          className
        )}
        style={{
          willChange: 'opacity',
        }}
      />

      <div
        className={cn(
          'absolute -top-[130px] left-1/2 -z-[1] h-[992px] w-full max-w-[1460px] -translate-x-1/2 bg-[image:var(--background-svg)] bg-[length:1460px_auto] bg-[position:80%_-45%] bg-no-repeat md:bg-[position:90%_-55%] lg:bg-[position:90%_50%] xl:bg-[position:center] xl:blur-[30px]',
          className
        )}
        style={
          {
            'willChange': 'opacity',
            '--background-svg': `url("data:image/svg+xml,${background}")`,
          } as React.CSSProperties
        }
      />
    </>
  );
}
